/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams, Link, useLocation, Navigate } from 'react-router-dom';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { MdOutlineEdit } from 'react-icons/md';
import { CiTrash } from 'react-icons/ci';
import { FaRegCopy } from 'react-icons/fa';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  CircularProgress,
  FormControl,
  FormLabel,
  Select,
} from '@mui/material';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// components
import Swal from 'sweetalert2';
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import appConfig from '../config';
import USERLIST from '../_mock/user';
import {
  deleteSpecialAccess,
  deleteUser,
  getAllSpecialAcess,
  getBnbList,
  getUsers,
  getAllCity,
  deleteCity,
  getSmartHomeDeviceByBNB,
  getCityWiseBnB,
} from '../helper/backend_helper';

// ----------------------------------------------------------------------

export default function DevicesPage() {
  const navigate = useNavigate();
  const [bnb, setBnB] = useState('');
  const [users, setUsers] = useState([]);
  const [devicesData, setDevicesData] = useState([]);
  const [data, setData] = useState([]);
  console.log(data);
  console.log(devicesData);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const [loading, setLoading] = useState(false);

  const getDevices = async () => {
    try {
      const res = await getSmartHomeDeviceByBNB(bnb);
      setDevicesData(res?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDevices();
  }, [bnb]);

  const fetchCityWiseBnB = async () => {
    try {
      setLoading(true)
      const res = await getCityWiseBnB();

     setData(res?.data?.data?.sort((a, b) => a.city.localeCompare(b.city)));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCityWiseBnB();
  }, []);

  // const encodedData = encodeURIComponent(JSON.stringify(clickedRow));
  return (
    <div className="bg-[#f4f4f4]  p-2">
      <Helmet>
        <title> Smart Home </title>
      </Helmet>

      {/* <Card sx={{ p: 3 }}>
        <Stack mb={3} direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4">Smart Home Devices</Typography>

          <Button
            sx={{
              boxShadow: 'none',
              backgroundColor: '#1E3A5F',
              '&:hover': {
                backgroundColor: '#1E3A5F',
                boxShadow: 'none',
              },
            }}
            variant="contained"
            endIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => navigate('/smart-homes/add_smart-home')}
          >
            Create New
          </Button>
        </Stack>

        <Scrollbar>
          <Stack mt={2} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>Select BnB</FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack>
            {Object.entries(devicesData)?.map(([roomName, devices]) => (
              <Stack key={roomName} mt={3}>
                <Typography variant="h5">{roomName}</Typography>
                {devices.map((device) => (
                  <Typography key={device.deviceName} variant="body1">
                    {device?.shellyDevice?.name || device?.smartThingDevice?.name}
                  </Typography>
                ))}
              </Stack>
            ))}
          </Stack>
        </Scrollbar>
      </Card> */}

   

      <div className="flex justify-between items-center ">
        <h1 className="text-3xl font-bold text-black">Smarts Units</h1>

        <input
          type="search"
          id="default-search"
          className="block w-72 p-4 ps-10 text-sm rounded-full outline-none text-gray-900 border border-none bg-white"
          placeholder="Search..."
          required
        />
      </div>

      {
        loading && (
          <div className="flex justify-center items-center h-screen">
            <CircularProgress />
          </div>
        )
      }


      {data?.map((data) => {
        return (
          <>
            <div className="mt-5">
              <h1>{data?.city}, Apulia, Italy</h1>
            </div>
            <div className="flex items-center gap-4 flex-wrap">
              {data?.bnbList?.map((data) => {
                return (
                  <div    onClick={() => navigate('/smartHomeDevicesDetail', { state: { bnb: data?.BnBShortName } })} className="bg-white mt-2 rounded-2xl p-3 w-56 flex flex-col gap-2">
                    <h1 className="text-2xl font-bold text-black">{data?.BnBShortName}</h1>
                    {data?.hasDevice ? (
                      <div className="flex justify-start items-center gap-2">
                        <div className="h-3 w-3 bg-green-300 rounded-full" />
                        <h1>Devices online</h1>
                      </div>
                    ) : (
                      <div />
                    )}
                    <div className="flex justify-between items-center">
                      {data?.hasDevice ? (
                        <div
                       
                          className="flex gap-2 cursor-pointer"
                        >
                          <span className="bg-[#4D56FF] w-24 text-center text-white text-[14px] font-thin dark:bg-[#4D56FF] px-4 py-0.5 rounded-2xl dark:text-white">
                            Request
                          </span>
                        </div>
                      ) : (
                        <div />
                      )}

                      <div className="flex gap-2">
                        <span className="bg-[#F4F4F4] w-24 text-center text-black text-[14px] font-thin  px-4 py-0.5 rounded-2xl dark:bg-[#F4F4F4] dark:text-black">
                          Settings
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        );
      })}
    </div>
  );
}
